import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LOGO_MARK } from "../assets/images";

function Header({ onApplyClick }) {
  const location = useLocation();
  const isRegister = location.pathname === "/register";

  return (
    <header className="shrink-0 border-b border-slate-200/80 bg-white px-3 py-2.5 shadow-sm sm:px-4">
      <div className="mx-auto flex w-full max-w-[min(100%,1400px)] items-center justify-between">
        {/* Logo + brand name — always links home */}
        <Link to="/" className="flex items-center gap-2 focus:outline-none">
          <img src={LOGO_MARK} alt="Chanuka Bursary" className="h-8 w-auto" />
          <span className="text-sm font-semibold text-slate-800">
            Chanuka Bursary
          </span>
        </Link>

        {/* Right-side nav */}
        <div className="flex items-center gap-2 sm:gap-3">
          {/* Register nav link — hide it when already on /register */}
          {!isRegister && (
            <Link
              to="/register"
              className="hidden rounded-full border border-[#0057A5] px-3 py-1.5 text-xs font-bold text-[#0057A5] transition hover:bg-[#0057A5]/5 focus:outline-none sm:inline-flex"
            >
              Register
            </Link>
          )}

          {/* Primary CTA */}
          <Link
            to="/register"
            className="apply-by-sms-cta apply-by-sms-blink rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wide text-white shadow disabled:opacity-70"
          >
            Click to Apply
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
